import { CSSProperties, MouseEventHandler, ReactNode } from "react"
import { ClassName, classNames } from "../Components"

interface BlockBaseProps {
  children?: ReactNode;
  className?: ClassName;
  style?: CSSProperties;
}

interface BlockProps extends BlockBaseProps {
  onClick?: MouseEventHandler;
}

interface BlockContainerProps extends BlockBaseProps {
  onClick?: MouseEventHandler;
}

interface BlockFieldProps extends BlockBaseProps {
  blank?: boolean;
  label?: string | ReactNode;
  labelAfter?: boolean;
  labelFor?: string;
  onClick?: MouseEventHandler;
}

interface BlockFieldInputsProps extends BlockBaseProps {
}

interface BlockFieldInputsDividerProps extends BlockBaseProps {
  divider?: string;
}

interface BlockRowProps extends BlockBaseProps {
  actions?: boolean;
}

export function Block({ children, className, onClick, style }: BlockProps) {
  return (
    <div className={classNames(["block", className])} onClick={onClick} style={style}>
      {children}
    </div>
  );
}

export function BlockContainer({ children, className, onClick, style }: BlockContainerProps) {
  return (
    <div className={classNames(["block-container", className])} onClick={onClick} style={style}>
      {children}
    </div>
  );
}

export function BlockField({ blank, children, className, label, labelAfter, labelFor, onClick, style }: BlockFieldProps) {
  return (
    <div className={classNames(["block-field", blank && "blank", className])} onClick={onClick} style={style}>
      {label != undefined && !labelAfter && <label htmlFor={labelFor}>{label}</label>}
      {children}
      {label != undefined && labelAfter && <label htmlFor={labelFor}>{label}</label>}
    </div>
  );
}

export function BlockFieldInputs({ children, className, style }: BlockFieldInputsProps) {
  return (
    <div className={classNames(["block-field-inputs", className])} style={style}>
      {children}
    </div>
  );
}

export function BlockFieldInputsDivider({ className, divider, style }: BlockFieldInputsDividerProps) {
  return (
    <span className={classNames(["block-field-inputs-divider", className])} style={style}>
      {divider || "|"}
    </span>
  );
}

export function BlockRow({ actions, children, className, style }: BlockRowProps) {
  return (
    <div className={classNames(["block-row", className, actions && "block-row-actions"])} style={style}>
      {children}
    </div>
  );
}
